/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, March 2020
 */

/**
 * Capitalize a string.
 *
 * @example
 * console.log(Utils.capitalize("some name")); // -> Some name
 *
 * @param {string} string String to capitalize
 * @returns {string} Capitalized string
 */
export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1, string.length);
}



// WEBPACK FOOTER //
// ./src/utils/strings.js